import React from "react";
import "../App.css";

const QuestionsAndFears: React.FC = () => {
  return <div className="QuestionsAndFears"> QuestionsAndFears</div>;
};

export default QuestionsAndFears;
